export default "__VITE_ASSET__53d989b0__"